const headRowsManagementBackups = {
  file: 'Archivo',
  createdAt: 'Fecha',
  createdBy: 'Autor',
  size: 'Talla',
  type: 'Tipo',
  ingested: 'Consumido',
  download: 'Download',
  edit: 'Editar'
};

export default headRowsManagementBackups;
